import Cookies from 'js-cookie';

const TokenKey = 'beesfpd_token';
const UserInfoKey = 'beesfpd_user_info';

export function getToken () {
  const localToken = localStorage.getItem(TokenKey);
  if (localToken) {
    return localToken;
  }
  return Cookies.get(TokenKey);
}

export function setToken (token, expires = 7) {
  localStorage.setItem(TokenKey, token);
  return Cookies.set(TokenKey, token, { expires });
}

export function removeToken () {
  localStorage.removeItem(TokenKey);
  return Cookies.remove(TokenKey);
}

export function getUserInfo () {
  const userInfo = localStorage.getItem(UserInfoKey);
  try {
    return userInfo ? JSON.parse(userInfo) : null;
  } catch (e) {
    return null;
  }
}

export function setUserInfo (userInfo) {
  localStorage.setItem(UserInfoKey, JSON.stringify(userInfo));
}

export function removeUserInfo () {
  localStorage.removeItem(UserInfoKey);
}

export function clearAuth () {
  removeToken();
  removeUserInfo();
}

export function isLoggedIn () {
  return !!getToken();
}



// WEBPACK FOOTER //
// ./src/utils/auth.js